<template>
  <div class="search-result">
    <!-- downloads -->
    <!-- @todo: a bit too risky? -->
    <template v-if="item.type === 'Downloads'">
      <a
        :href="item.pdf"
        class="search-result__link search-result__link--downloads">
        <div v-if="item.images.length" class="search-result__image">
          <responsive-image :images="item.images" />
        </div>
        <div v-else class="download__image--no-img"></div>
        <div v-if="item.type" class="search-result__type">
          {{ item.type }}
        </div>
        <div
          v-if="item.title"
          v-html="item.title"
          class="search-result__title"></div>
        <div v-if="item.pdf" class="search-result__download">
          <div class="search-result__pdf search-result__pdf--downloads"></div>
        </div>
      </a>
    </template>

    <!-- the rest -->
    <template v-else>
      <a :href="item.link" class="search-result__link">
        <div v-if="item.images.length" class="search-result__image">
          <responsive-image :images="item.images" />
        </div>
        <div v-if="item.type" class="search-result__type">
          {{ item.type }}
        </div>
        <div
          v-if="item.title"
          v-html="item.title"
          class="search-result__title"></div>
      </a>
      <div v-if="item.pdf" class="search-result__download">
        <a
          :href="item.pdf"
          :class="`search-result__pdf--${stringify(item.key)}`"
          class="search-result__pdf"></a>
      </div>
    </template>
  </div>
</template>

<script>
// components
import ResponsiveImage from '../elements/ResponsiveImage';

export default {
  name: 'search-result',
  components: {
    ResponsiveImage,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  methods: {
    stringify(string) {
      if (!string) return;
      return string.toLowerCase().replace(/ +/g, '-');
    },
  },
};
</script>
